"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _Duration = _interopRequireDefault(require("web/shared/telemetry/components/Duration"));
var _MarkerMeaning = _interopRequireDefault(require("web/shared/telemetry/components/MarkerMeaning"));
var _Percent = _interopRequireDefault(require("web/shared/telemetry/components/Percent"));
var _PhaseBreakdownData = require("web/shared/telemetry/charts/PhaseBreakdown.data.js");
var _heat = require("web/shared/telemetry/format/heat.js");
var _PhaseBreakdownStyles = require("web/shared/telemetry/charts/PhaseBreakdown.styles.js");
var _perfTablesStyles = require("web/shared/telemetry/perfTables.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The stacked bar and the phase table beneath it, sharing one hover state so
* pointing at either lights the other.
*
* Color in the table runs down each column, not across a row. A column is one
* statistic measured the same way for every phase, so its cells are
* comparable; a row mixes a single worst reading with three cohort means, and
* coloring those against each other says nothing.
*/
function PhaseBreakdownDetail(_ref) {
  let records = _ref.records,
    markerMeanings = _ref.markerMeanings;
  const _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    hovered = _useState2[0],
    setHovered = _useState2[1];
  const cohorts = (0, _PhaseBreakdownData.buildPhaseCohorts)(records);
  const phases = cohorts.all;
  if (phases.length === 0) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("p", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.muted)), {}, {
      children: "This metric records no markers, so there are no phases to break its time into. Declaring one is adding a MetricMarkerDefinition to its declaration."
    }));
  }
  const columns = (0, _PhaseBreakdownData.shownColumns)(cohorts); // One heat scale per column, built from that column's own figures.
  const heatOf = new Map(columns.map(column => [column.key, (0, _heat.columnHeat)(phases.map((unused, index) => column.valueOf(cohorts, index)))]));
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_PhaseBreakdownStyles.styles.phaseBar)), {}, {
      onMouseLeave: () => setHovered(null),
      children: phases.map((phase, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_PhaseBreakdownStyles.styles.phaseSegment, index === hovered && _PhaseBreakdownStyles.styles.phaseSegmentActive)), {}, {
        style: {
          flexGrow: Math.max(phase.share, 0.001)
        },
        onMouseEnter: () => setHovered(index)
      }), phase.label))
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.tableWrap)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.table)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.headCell, _perfTablesStyles.styles.dividedCell)), {}, {
              children: "phase"
            })), columns.map(column => /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericHeadCell, _perfTablesStyles.styles.dividedCell)), {}, {
              children: column.label
            }), column.key))]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
          onMouseLeave: () => setHovered(null),
          children: phases.map((phase, index) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", (0, _objectSpread2.default)((0, _objectSpread2.default)({
            onMouseEnter: () => setHovered(index)
          }, stylex.props(_PhaseBreakdownStyles.styles.phaseRow, index === hovered && _PhaseBreakdownStyles.styles.phaseRowActive)), {}, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.cell, _perfViewsStyles.styles.mono, _perfTablesStyles.styles.dividedCell)), {}, {
              children: [phase.label, /*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkerMeaning.default, {
                marker: phase.boundaryMarker,
                meanings: markerMeanings
              })]
            })), columns.map(column => {
              var _heatOf$get;
              const value = column.valueOf(cohorts, index);
              const color = (_heatOf$get = heatOf.get(column.key)) === null || _heatOf$get === void 0 ? void 0 : _heatOf$get(value);
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("td", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericCell, _perfTablesStyles.styles.dividedCell)), {}, {
                children: column.format === "percent" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Percent.default, {
                  share: value !== null && value !== void 0 ? value : 0,
                  color: color
                }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Duration.default, {
                  ms: value,
                  color: color
                })
              }), column.key);
            })]
          }), phase.label))
        })]
      }))
    }))]
  });
}
var _default = exports.default = PhaseBreakdownDetail;